import { render, staticRenderFns } from "./DispatchSheet.vue?vue&type=template&id=119bd698&"
import script from "./DispatchSheet.vue?vue&type=script&lang=js&"
export * from "./DispatchSheet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports